import { useTranslation } from '@wix/wix-i18n-config';
import cs from 'classnames';
import React from 'react';

import { templatePreviewModalDataHooks } from '../TemplatePreviewModal.dataHooks';
import s from './PreviewHeader.scss';
import WixStudioLogo from './WixStudioLogo.svg';
import Desktop from './Desktop.svg';

type Props = {
  onButtonClick: () => void;
};

export const PreviewHeader: React.FC<Props> = ({ onButtonClick }) => {
  const { t } = useTranslation();

  return (
    <>
      <div
        className={s.previewHeader}
        data-hook={templatePreviewModalDataHooks.previewHeader()}
      >
        <WixStudioLogo className={s.logo} />
        <button onClick={onButtonClick} className={cs(s.button, s.buttonWrap)}>
          {t('app.templates.saveTemplate.saveButton.text')}
        </button>
      </div>
      <div className={s.goToDesktop}>
        <Desktop />
        <div>{t('app.template.viewer.goToBiggerScreen')}</div>
      </div>
    </>
  );
};
